import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { AppWindow } from '../mockups/AppWindow';
import { PlannerMock } from '../mockups/PlannerMock';
import { ParallaxFrame } from '../ui/ParallaxFrame';
import { Reveal } from '../ui/Reveal';
export function Clarity() {
  const {
    t
  } = useLanguage();
  return <section id="claridad" className="overflow-hidden bg-canvas py-28 md:py-40" data-id="element-131" data-mp="3li3rloaj7sf6">
      <div className="mx-auto max-w-6xl px-5 md:px-6" data-id="element-132" data-mp="d18xoybppid8">
        <div className="grid items-end gap-6 md:grid-cols-2 md:gap-16" data-id="element-133" data-mp="d3v5mz2ilzvz">
          <Reveal data-id="element-134" data-mp="i0298l7fuzar">
            <h2 className="text-5xl font-semibold leading-[1.02] tracking-[-0.035em] text-graphite md:text-7xl" data-id="element-135" data-mp="i2oluz96s4zu">
              {t.clarity.title}
            </h2>
          </Reveal>
          <Reveal delay={0.08} data-id="element-136" data-mp="88zbntdpx2g8">
            <p className="max-w-md text-lg leading-snug text-subtle md:pb-2 md:text-2xl" data-id="element-137" data-mp="w0d5y4vfj83u">
              {t.clarity.text}
            </p>
          </Reveal>
        </div>
        <ParallaxFrame className="mt-14 md:mt-20" data-id="element-138" data-mp="10sebz92082lf">
          <AppWindow data-id="element-139" data-mp="45znz2dtdthj">
            <PlannerMock data-id="element-140" data-mp="47aqkyviwv72" />
          </AppWindow>
        </ParallaxFrame>
      </div>
    </section>;
}